import {Injectable} from '@angular/core';
import {AuditService} from '@webmate-web-core/shared/services/audit.service';
import {ArtifactService} from '@webmate-web-core/shared/services/artifact.service';
import {AuditActivityId, AuditId} from '@webmate-web-core/shared/types/ids';
import {TestService} from '@webmate-web-core/shared/services/test.service';
import {AuditSession} from './audit-session';
import {Observable, Subject} from 'rxjs';
import {WorkbenchContextService} from './workbench-context.service';

@Injectable()
export class WorkbenchAuditService {

    activeAuditId: AuditId | undefined;
    activeActivity: AuditActivityId | undefined;

    private auditSessions: { [key: AuditId]: AuditSession } = {};

    private focusActivityCommand: Subject<string> = new Subject();
    focusActivityCommandChange$(): Observable<string>{
        return this.focusActivityCommand.asObservable();
    }
    focusActivity(activityId: string){
        this.focusActivityCommand.next(activityId);
    }

    constructor(private readonly auditService: AuditService,
                private readonly artifactService: ArtifactService,
                private readonly testService: TestService,
                private readonly workbenchContextService: WorkbenchContextService) {}

    getOrCreateAuditSession(auditId: AuditId): AuditSession {
        if(!(auditId in this.auditSessions) && !!auditId){
            this.auditSessions[auditId] = new AuditSession(auditId, this.auditService, this.artifactService, this.testService);
        }

        return this.auditSessions[auditId];
    }

    /**
     * Updates the `activeActivity` in the workbench context.
     */
    public setActiveActivity(activityId: AuditActivityId): void {
        const context = this.workbenchContextService.getCurrentWorkbenchContext();

        this.activeAuditId = context?.auditContext?.activeAudit;
        if (!this.activeAuditId) {
            return;
        }
        if (context?.auditContext?.activeAuditActivity?.id === activityId) {
            this.activeActivity = activityId;
            return;
        }

        const currentAuditInfo = this.getOrCreateAuditSession(this.activeAuditId).getCurrentAuditInfo();
        const activityInfo = currentAuditInfo.idToAssessmentTask?.[activityId];
        if (activityInfo) {
            this.activeActivity = activityId;
            this.workbenchContextService.setContextActiveAuditActivity(activityInfo);
        }
    }
}
